<template>
  <v-form v-model="formValid" ref="form" @submit.prevent="handleSubmit">
    <v-row justify="center">
      <v-col md="12" col="12">
        <v-card class="card-reasons">
          <v-card-text class="card-reasons-body">
            <h2 v-if="reasons.length > 1" class="black--text py-3" v-html="$t('booking.booking_reason')"></h2>
            <v-select
              v-if="reasons.length > 1"
              class="rounded-lg"
              v-model="reason"
              :items="reasons"
              :placeholder="$t('booking.booking_reason')"
              item-text="name" item-value="id"
              color="primary"
              outlined return-object
              @change="chooseReason(reason)"
              data-testid="ReasonPass-Reasons"
            >
              <template v-slot:item="{ item }">
                <v-row dense>
                  <v-col>
                    <span v-html="item.toString()" :data-testid="`ReasonPass-LabelReason-` + item.toString()"></span>
                  </v-col>
                </v-row>
              </template>
            </v-select>
            <h2 v-if="zones.length > 0" class="black--text py-3" v-html="$t('booking.booking_zone_label')" />
            <v-select
              v-if="zones.length > 0"
              v-model="zone"
              class="rounded-lg"
              :items="zones" :placeholder="$t('booking.booking_zone')" :item-text="setLabelZoneOption" :hint="zone.description ? `${zone.description}` : ''"
              :rules="branch.auto_assing_table ? [rules.required] : []"
              item-value="id" color="primary" outlined return-object persistent-hint data-testid="ReasonPass-Zones"
              @change="chooseZone(zone)"
            >
              <template v-slot:item="{ item }">
                <v-row dense>
                  <v-col>
                    <span :data-testid="`ReasonPass-LabelZone-` + item.name">
                      {{ setLabelZoneOption(item) }}
                    </span>
                  </v-col>
                </v-row>
              </template>
            </v-select>
            <h2 v-if="services.length > 1" class="black--text py-3" v-html="$t('booking.booking_service')"></h2>
            <v-select
              v-if="services.length > 1"
              class="rounded-lg"
              v-model="serviceBook"
              :items="services"
              :placeholder="$t('booking.booking_service')"
              item-text="name" item-value="id"
              color="primary"
              outlined return-object
              @change="chooseService(serviceBook)"
              :hint="`${serviceBook.description}`"
              persistent-hint
              data-testid="ReasonPass-Services"
            >
              <template v-slot:item="{ item }">
                <v-row dense>
                  <v-col>
                    <span v-html="item.label" :data-testid="`ReasonPass-LabelService-` + item.label"></span>
                  </v-col>
                </v-row>
              </template>
            </v-select>
            <h2 v-if="products.length > 0" class="black--text py-3" v-html="getLabels('booking.booking_service_product')"></h2>
            <v-select
              v-if="products.length > 0"
              v-model="product"
              class="rounded-lg" item-text="label" item-value="id" color="primary" outlined return-object
              :items="products" :placeholder="getLabels('booking.booking_service_product')"
              @change="chooseProduct(product)"
              data-testid="ReasonPass-Products"
            >
              <template v-slot:item="{ item }">
                <v-row dense>
                  <v-col>
                    <span v-html="item.label" :data-testid="`ReasonPass-LabelProduct-` + item.label"></span>
                  </v-col>
                  <v-spacer />
                  <v-col>
                    <span v-html="$n(item.price, 'currency', instance.locale)" :data-testid="`ReasonPass-PriceProduct-` + item.label"></span>
                  </v-col>
                </v-row>
              </template>
            </v-select>
            <v-expand-x-transition v-if="products.length > 0">
              <v-card v-if="expand" width="180px" class="mx-auto">
                <v-img v-if="imageProduct" contain :src="imageProduct" alt="image-product">
                  <v-app-bar flat color="rgba(0, 0, 0, 0)">
                    <v-spacer />
                    <v-btn class="boton-image-book" x-small icon color="red" @click="deleteProductBook()">
                      <v-icon>fa-light fa-xmark</v-icon>
                    </v-btn>
                  </v-app-bar>
                </v-img>
              </v-card>
            </v-expand-x-transition>
            <p v-if="serviceBook.description.length > 0" class="black--text mb-0 my-2">
              <v-icon color="black" x-small>fa-solid fa-circle-exclamation</v-icon>
              {{ labelService }}
            </p>
            <p v-if="product.id.length > 0" class="black--text mb-0 my-2">
              <v-icon color="black" x-small>fa-solid fa-circle-exclamation</v-icon>
              {{ labelProduct }}
            </p>
            <p v-if="zone.id" class="black--text mb-0 my-2">
              <v-icon color="black" x-small>fa-solid fa-circle-exclamation</v-icon>
              {{ setLabelZoneOption(zone) }}
            </p>
            <div v-if="serviceBook.description.length > 0 || product.id.length > 0">
              <p
                v-for="(item,index) in fecha.horaObj.reservation_modes" :key="item.id"
                class="black--text mb-0 my-2"
              >
                <template v-if="fecha.horaObj.reservation_modes.length">
                  <v-icon color="black" x-small>fa-solid fa-circle-exclamation</v-icon>
                  {{ labelReservation[index] }}
                </template>
              </p>
            </div>
            <p v-if="!product && product.description !== null && product.description.length > 0" class="black--text mb-0 my-2" v-html="product.description"></p>
            <h2 class="black--text py-3 observations_health" v-html="$t('booking.observations_health')"></h2>
            <v-textarea
              v-model="reservation.observation"
              class="rounded-lg observations_health" color="primary"
              :placeholder="$t('booking.observations_health_placeholder')"
              rows="4" row-height="30" outlined
              data-testid="ReasonPass-Observations"
            />
            <div v-if="instance.slug === 'the-rose-tea-room'" >
              <h2 class="black--text py-3"> Nuestros Tiers:</h2>
              <ul>
                <li>Desayuno</li>
                <li>Brunch</li>
                <li>Tradicional de sal</li>
                <li>Tradicional dulce</li>
                <li>Tier edición especial</li>
                <li>High tea de temporada</li>
              </ul>
            </div>
            <h2 v-if="instance.slug !== 'the-rose-tea-room'" class="black--text py-3 commentary-label-title" v-html="$t('booking.commentary_label')"></h2>
            <h2 v-else class="black--text py-3" v-html="'Por favor indicar el Tier que va a consumir cada una de las personas de la reserva.'"></h2>
            <v-textarea
              v-model="reservation.customer_comment"
              class="rounded-lg commentary-label-textarea" color="primary"
              rows="4" row-height="30" outlined
              data-testid="ReasonPass-CustomerComment"
            />
            <span
              v-if="branch.policies_book !== null && branch.policies_book.length > 18"
              class="primary--text text-decoration-underline"
              @click="opneModalPolicies()" v-html="$t('booking.booking_label_part2')"
            ></span>
          </v-card-text>
        </v-card>
        <v-dialog
          v-model="policies"
          persistent
          transition="dialog-transition" class="rounded-lg"
        >
          <v-card class="modal-policies-reservation container">
            <v-card-title class="font-weight-black" primary-title v-html="$t('booking.booking_label_part2')" />
            <v-card-text v-html="branch.policies_book" />
            <v-card-actions class="justify-center">
              <v-btn
                color="primary"
                class="text-capitalize"
                v-html="$t('booking.policies_agree')"
                @click="policies=false"
              />
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-footer app class="pa-0">
          <v-container>
            <v-btn
              class="button-nextpass text-capitalize"
              large block color="primary"
              v-html="$t('messages_error.continuar')"
              type="submit"
              data-testid="ReasonPass-NextPass"
            />
          </v-container>
        </v-footer>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapMutations,mapState,mapGetters } from "vuex";
import { track } from "@/services/track-custom";
import { menu } from "@/services/menu";
import { reservas } from "@/services/reservas";
import { shoppingCart } from "@/services/shoppingCart";
import { profile } from '@/services/profile';

export default {
  name: "ReasonPass",
  props: {
    reservation: Object,
    branch: Object,
    fecha: Object
  },
  data() {
    return {
      imageProduct: "",
      expand: true,
      shoppingCart: { total: 0 },
      date: new Date().toISOString().substr(0, 10),
      nextStepper: false,
      menu: false,
      zones: [],
      reasons: [],
      zone: "",
      serviceBook: { description: "" },
      product: { id: "" },
      reason: "",
      services: "",
      products: [],
      idDeleteProduct: null,
      next: true,
      policies: false,
      formValid: false,
      rules: {
        required: (v) => !!v || this.$t('booking.required_field')
      },
    };
  },
  watch: {
    product(valNew, valOld) {
      valNew;
      if (valOld && valOld.id.length !== 0) this.getShoppingCartReserve();
    }
  },
  computed: {
    ...mapState('customer', ["supplier", "instance"]),
    ...mapState('profile', ["session","profile"]),
    ...mapState('bookings', ["bookPurchaseId"]),
    ...mapState('order', ["service"]),
    ...mapGetters('customer',['getLabels']),
    labelProduct() {
      let labelData = null;
      labelData = (this.products.length > 0 && this.product.label) ? this.product.label + " " +  this.$i18n.n(this.product.price, "currency", this.instance.locale) : null;
      return labelData;
    },
    labelReservation() {
      let labelBook = [];
      this.fecha.horaObj.reservation_modes.map(item => {
        if(item.code === 'cover') labelBook.push(
            this.$t('booking.is_cover') + `  ` +
            this.$n(item.reservation_fee,'currency',this.instance.locale) + `  ` +
            (item.deductible ? this.$t('booking.consumible_label') + ` ` + this.$n(item.deductible_value,'currency', this.instance.locale) : this.$t('booking.no_consumible_label'))
          );
        if(item.code === 'table') labelBook.push(
            this.$t('booking.is_fix') + `  ` +
            this.$n(item.reservation_fee,'currency',this.instance.locale) + `  ` +
            (item.deductible ? this.$t('booking.consumible_label') + ` ` + this.$n(item.deductible_value,'currency', this.instance.locale) : this.$t('booking.no_consumible_label'))
          );
        if(item.code === 'person') labelBook.push(
            this.$t('booking.is_person') + `  ` + this.reservation.cuantos + ' ' + this.$t('common.persons_label') + ' ' +
            this.$n(item.reservation_fee,'currency',this.instance.locale) + `  ` +
            (item.deductible ? this.$t('booking.consumible_label') + ` ` + this.$n(item.deductible_value,'currency', this.instance.locale) : this.$t('booking.no_consumible_label'))
        );
      });
      return labelBook;
    },
    labelService () {
      let labelData = null;
      labelData = this.services.length > 0 ? this.serviceBook.label : null;
      return labelData;
    }
  },
  created () {
    if (this.product && Number(this.product.price) === 0 && this.bookPurchaseId.length) this.SetBookPurchaseId(null);
  },
  methods: {
    ...mapMutations('bookings', ["SetBookPurchaseId"]),
    getShoppingCartReserve () {
      shoppingCart.getProductsCart()
        .then(response => {
          this.shoppingCart = response;
        });
    },
    handleSubmit () {
      if (this.$refs.form.validate()) this.cambioPaso();
    },
    cambioPaso() {
      this.$emit("nextPass", "paso3");
    },
    async getServicesZones () {
      try {
        const response = await reservas.getServicesZones(this.reservation.branch_id,this.reservation.scheduleday_id);
        if (response) {
          this.getProducts();
          this.services = response.data.services;
          this.services.unshift({
            label: this.getLabels('UNSPECIFIED'),
            name: this.getLabels('UNSPECIFIED') ,
            description: "",
            id: null,
            price: 0,
            value: null
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getProducts() {
      try {
      const response = await menu.getProducts();
      if (response) this.products = response.data.productos.filter(element => element.out_of_stock === false);
      } catch (error) {
        console.error(error);
      };
    },
    chooseProduct(data) {
      try {
        this.imageProduct = "";
        if (data.image !== null) this.imageProduct = data.image.blog;
        data.configs = [];
        data.attachs = [];
        data.count = 1;
        this.reservation.product_id = data.id;
        this.reservation.product_price = data.price;
        this.reservation.descriptionProduct = this.labelProduct;
        this.createBookPurchaseId(data);
      } catch (error) {
        console.error(error);
      };
    },
    chooseReason(data) {
      this.reason = data;
      this.reservation.cause = this.reason;
    },
    chooseZone(data) {
      this.zone = data;
      let zoneReservationFee = Number(this.zone.reservation_fee);
      if (zoneReservationFee > 0 && this.bookPurchaseId === null) this.createBookPurchaseId({});
      this.reservation.zone_id = this.zone.id;
      this.reservation.zone_label = this.zone.name || this.zone.label;
      if(this.branch.auto_assing_table && this.zone) this.formValid = true;
    },
    createBookPurchaseId(data) {
      let data_purchase = {
        customer_id: this.instance.id,
        supplier_id: this.supplier.id,
        session_id: this.session.id,
        service: this.service
      };
      let response = null;
      this.validateProfile();
      this.getDatesTimeout = setTimeout(async () => {
        try {
          if (this.reservation.product_id && this.reservation.product_id.length) response = await shoppingCart.BookAddProductToCart(this.bookPurchaseId,data_purchase,data);
          else response = await shoppingCart.BookAddProductToCart(this.bookPurchaseId,data_purchase);
          if (response !== null) {
          if (this.bookPurchaseId === null) this.SetBookPurchaseId(response.data.id);
          if (this.reservation.product_id && this.reservation.product_id.length) {
              this.idDeleteProduct = response.data.purchase_product_id;
              track.trackEventCluvi({ product: this.product }, "add product");
              track.trackEventAddCart(this, this.instance, this.product);
            };
          };
        } catch (error) {
          console.error(error);
        };
      }, 1000);
    },
    chooseService(data) {
      this.serviceBook = data;
      if (this.serviceBook.price > 0 && this.serviceBook.value && this.bookPurchaseId === null) this.createBookPurchaseId({});
      this.reservation.siteservice_id = this.serviceBook.id;
      this.reservation.siteservice_label = this.serviceBook;
    },
    async deleteProductBook() {
      try {
        const resp  = await shoppingCart.deleteProductBook(this.idDeleteProduct);
        if(resp.status === 204) {
          this.imageProduct = "";
          this.product = { id: "" };
        };
      } catch(error) {
        console.error(error);
      };
    },
    opneModalPolicies() {
      if(this.branch.policies_book !== null && this.branch.policies_book.length > 18) this.policies = true;
      else this.policies = false;
    },
    getLabelByFeeType(type) {
      let label = '';
      if(type === 'table') label = `- ${this.$i18n.t('booking.by_table')}`
      else if(type === 'person') label = `- ${this.$i18n.t('booking.by_person')}`
      return label;
    },
    setLabelZoneOption(zone) {
      return zone.id ? `${zone.name}: ${this.$i18n.n(zone.reservation_fee, "currency", this.instance.locale)}  ${this.getLabelByFeeType(zone.reservation_fee_type)}`:
      zone.name;
    },
    async validateProfile () {
      try {
        if (!this.profile.id && !this.profile.token) await profile.init();
      } catch (error) {
        console.error(error);
      };
    }
  },
  mounted() {
    this.reasons = this.branch.reasons_book;
    this.zones = Object.entries(this.fecha.horaObj.zones).map((zone) => ( zone[1] ));
    this.opneModalPolicies();
    this.getServicesZones();
  }
};
</script>

<style lang="scss">
  .modal-policies-reservation {
    font-family: 'Poppins', sans-serif !important;
    border-radius: 8px !important;
  }
  .card-reasons {
    font-family: 'Poppins', sans-serif !important;
  }
  .body-button-nextpass {
    font-family: 'Poppins', sans-serif !important;
    display: flex;
    flex-direction: column;
    height: 6rem;
    width: 100%;
    .button-nextpass {
      margin: 2rem 3rem 3rem 3rem;
      height: 3rem !important;
      border-radius: 10px !important;
    }
  }
  .boton-image-book {
    margin-right: -10px !important;
    margin-top: -30px !important;
  }
</style>
